import {
  fetchCategoryStart,
  fetchCategorySuccess,
  fetchCategoryFailure,
} from "../GetCategory/reducer";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_ALL_CATEGORY } from "../../constants/constants";

export const getAllCategory = (setLoading) => async (dispatch) => {
  try {
    setLoading(true);
    dispatch(fetchCategoryStart());

    const response = await determineBaseUrlAndPerformApiCall(
      GET_ALL_CATEGORY,
      "GET",
    );
    setLoading(false);
    dispatch(fetchCategorySuccess(response));
  } catch (error) {
    dispatch(fetchCategoryFailure(error.message));
  }
};
